import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  bodmasTestSeriesData: [],
  totalBodmasTestSeries: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
  isImageOpenModal: false,
}

export const bodmasTestSeriesSlice = createSlice({
  name: "bodmasTestSeries",
  initialState,
  reducers: {
    setBodmasTestSeriedData(state, { payload }) {
      state.bodmasTestSeriesData = payload.result
      state.totalBodmasTestSeries = payload.total
    },
    pushTestSeriesData(state, { payload }) {
      state.bodmasTestSeriesData.push(payload)
      state.totalBodmasTestSeries +=1
    },
    updateTestSeriesData(state, { payload }) {
      const objIndex = state.bodmasTestSeriesData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.bodmasTestSeriesData[objIndex] = payload
      }
    },
    deleteTestSeriesData(state, { payload }) {
      const objIndex = state.bodmasTestSeriesData.findIndex((obj) => obj._id === payload);      
      if (objIndex >= 0) {
        state.bodmasTestSeriesData.splice(objIndex, 1)
        state.totalBodmasTestSeries -=1
      }
    },
    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    }
  }
})

export const { setBodmasTestSeriedData, updateTestSeriesData, deleteTestSeriesData, pushTestSeriesData, isOpenModal,
  ModalToggle, isOpenStatusModal, statusToggle, ImagestatusToggle, isImageOpenModal } = bodmasTestSeriesSlice.actions;

export default bodmasTestSeriesSlice.reducer;

export function getBodmasTestSeries(limit, offset, status, keyword, categoryId = '') {
  return async function getTestSeriesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getBodmasTestSeries(limit, offset, status, keyword, categoryId).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setBodmasTestSeriedData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addBodmasTestSeries(payload) {
  return async function addBodmasTestSeriesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addBodmasTestSeries(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushTestSeriesData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateBodmasTestSeries(id, data) {
  return async function updateBodmasTestSeriesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateBodmasTestSeries(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateTestSeriesData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function statusUpdateBodmasTestSeries(payload) {
  return async function statusUpdateBodmasTestSeriesThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdateBodmasTestSeries(payload.id, payload.status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(updateTestSeriesData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function statusDeleteBodmasTestSeries(payload) {
  return async function statuseleteBodmasTestSeriesThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdateBodmasTestSeries(payload.id, payload.status).then(
        (response) => {          
          dispatch(deleteTestSeriesData(payload.id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function updateTestSeriesImage(id, file) {
  return async function updateTestSeriesImageThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      dispatch(isImageOpenModal())
      await service.testSeriesImage(id, file).then(
        (response) => {
          dispatch(updateTestSeriesData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}